/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
import React from 'react';

export const GradientAvatar = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69 71">
    <title>Gradient avatar</title>
    <path
      id="Shape"
      d="M42.81585,7.66105a16.00318,16.00318,0,1,0,6.96348,15.82783A16.6276,16.6276,0,0,0,50,21.03495,16.02756,16.02756,0,0,0,42.81585,7.66105Z"
      fill="none"
    />
    <path
      id="Shape-2"
      dataname="Shape"
      d="M65.72173,71a3.33923,3.33923,0,0,0,3.211-4A37.681,37.681,0,0,0,64.8043,56L58,57.58974a29.84437,29.84437,0,0,1,4.43426,10.82048A3.368,3.368,0,0,0,65.72173,71Z"
      fill="#5f9501"
    />
    <path
      id="Shape-3"
      dataname="Shape"
      d="M.09277,67.05315A3.1863,3.1863,0,0,0,.639,69.734,3.08769,3.08769,0,0,0,3.13272,71a3.20378,3.20378,0,0,0,2.99246-2.33333h0A29.34,29.34,0,0,1,18,50L6.12518,52.92907A34.71873,34.71873,0,0,0,.09277,67.05315Z"
      fill="#5f9501"
    />
    <path
      id="Shape-4"
      dataname="Shape"
      d="M54.27905,44.52765l-.56816-.48026c-.81519-.55608-1.53157-1.01106-2.22324-1.3902L50.35133,42,38,44.95735A29.14675,29.14675,0,0,1,58.55261,58L65,56.45814A35.77254,35.77254,0,0,0,54.27905,44.52765Z"
      fill="#5f9501"
    />
    <path
      id="Shape-5"
      dataname="Shape"
      d="M48.83833,40.99l2.51694-2.71357A23.57325,23.57325,0,0,0,58,23l-6.87125,1.608A16.39354,16.39354,0,0,1,21.605,31.49246l-6.92158,1.608a23.77043,23.77043,0,0,0,3.47337,4.799l2.819,3.01507-3.64957,2.0603a29.20384,29.20384,0,0,0-2.91965,1.8593A36.84381,36.84381,0,0,0,6,53l12.58471-2.96482a29.1104,29.1104,0,0,1,20.13552-4.69849L51.30494,42.397Z"
      fill="#79b61d"
    />
    <path
      id="Shape-6"
      dataname="Shape"
      d="M18.88946,22.08984A15.57366,15.57366,0,0,1,21.17738,14l-8.22622,1.85547A20.96491,20.96491,0,0,0,12,22.08984,21.87614,21.87614,0,0,0,14.93059,33L22,31.41667A15.64837,15.64837,0,0,1,18.88946,22.08984Z"
      fill="#c8d200"
    />
    <path
      id="Shape-7"
      dataname="Shape"
      d="M51.35453,22.48954A16.99812,16.99812,0,0,1,51.12862,25l6.85252-1.6067A22.74683,22.74683,0,0,0,51.93185,7L44,8.85774A16.394,16.394,0,0,1,51.35453,22.48954Z"
      fill="#c8d200"
    />
    <path
      id="Shape-8"
      dataname="Shape"
      d="M35.08916,6.37594a16.7785,16.7785,0,0,1,9.00577,2.5985L52,7.21805l-.30019-.31279A23.19754,23.19754,0,0,0,35.16421,0h-.22515A22.95055,22.95055,0,0,0,13,16l8.00513-1.80451A16.43992,16.43992,0,0,1,35.08916,6.37594Z"
      fill="#c8d200"
    />
  </svg>
);
